import React from 'react'
import './s4.scss';

const data = [
  {
    desc: "Institución legítima, seguridad de información garantizada.",
    icon: "good"
  },
  {
    desc: "Control de riesgos profesional, asignación inteligente del monto adecuado para ti.",
    icon: "shield"
  },
]

const S4 = () => {
  return (
    <div className="gogo-s-4">
      <p className="s-desc">
        GoGo Credi es una plataforma de préstamos inteligente y conveniente, diseñada para usuarios que necesitan
        liquidez. Todo el proceso es 100% en línea, sin necesidad de aval, con aprobación rápida y montos flexibles.
        ¡Solicita tu préstamo en cualquier momento y lugar para resolver tus necesidades financieras!
      </p>
      <div className="data-wrapper">
        {
          data.map(item => (
            <div className="card" key={item.icon}>
              <div className={`icon ${item.icon}`}></div>
              <p className="desc">{item.desc}</p>
            </div>
          ))
        }
      </div>
      <div className="colleague absolute"></div>
      <div className="dollar-7 absolute"></div>
      <div className="dollar-8 absolute"></div>
      <div className="spark-4 absolute"></div>
    </div>
  )
}

export default S4;
